/**
 * brandColors ─ Penlytics ブランドカラー単一定義 (= iter 29 / Phase 8、 2026-05-14)
 *
 * 目的:
 *   - 47+ component に散在する `const PRIMARY = '#4f46e5'` を中央集約
 *   - theme.palette と完全同期 (= 同じ値を両方から参照)
 *
 * 使い方:
 *   import { BRAND_PRIMARY } from '../theme/brandColors';
 *   <Box sx={{ color: BRAND_PRIMARY }} />
 *   または MUI theme 経由:
 *   <Box sx={{ color: 'primary.main' }} />
 *
 * 注意:
 *   - 新規 component では theme.palette 経由を優先
 *   - 既存の `const PRIMARY = '#4f46e5'` の置換は段階的に
 */

// メインブランド (= 紫、 「Penlytics」 そのもの)
export const BRAND_PRIMARY = '#4f46e5';
export const BRAND_PRIMARY_DARK = '#4338ca';
export const BRAND_PRIMARY_LIGHT = '#eef2ff';

// JPYC グリーン (= 決済 + 残高表示)
export const JPYC_GREEN = '#16a34a';
export const JPYC_GREEN_DARK = '#15803d';

// HashPort ブルー (= Wallet 接続 UI)
export const HASHPORT_BLUE = '#0066ff';
export const HASHPORT_BLUE_DARK = '#0052cc';

// PayPal ブルー
export const PAYPAL_BLUE = '#003087';
